<template>
  <div class="ui-kit-main">
    <h2>Loader</h2>
    <div class="row">
      <div class="col-3">
        <app-loader></app-loader>
      </div>
      <div class="col-3">
        <app-loader isCircle></app-loader>
      </div>
    </div>
    <router-view :key="$route.name" />
  </div>
</template>

<script>
export default {
  name: 'MainUiKit',
  components: {
    AppLoader: () => import('@/components/ui/AppLoader'),
  },
};
</script>

<style lang="scss" scoped>
// -
</style>
